'use client';
import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    /**
   * Position of the button.
   * Available options: 'left', 'right'
   */ buttonPosition: PropTypes.oneOf([
        'left',
        'right'
    ])
};
/**
 * @subcomponent Tabs
 */ const TextInputWithButtonInset = createComponent({
    displayName: 'TextInputWithButtonInset',
    root: 'div',
    propTypes,
    propConfig: {
        classNames (props) {
            const classesSet = new Set([
                'swan-vanilla-ignore',
                'swan-input-with-button-inset'
            ]);
            if (props.buttonPosition && props.buttonPosition === 'left') classesSet.add(`swan-input-with-button-left`);
            return classesSet;
        }
    }
});

export { TextInputWithButtonInset };
